<div [formGroup]="vehicleForm">
  @if(showDriverForm){
    <h4>Datos del Chofer</h4>
    <div class="row" formGroupName="driver">
      <div class="col">
        <div class="form-floating my-3">
          <select [(ngModel)]="idType" [ngModelOptions]="{standalone: true}" class="form-control">
            <option value="id">
              Cédula
            </option>
            <option value="passport">
              Pasaporte
            </option>
          </select>
          <label>Tipo de identificación</label>
        </div>
        <div class="form-floating my-3">
          <input [formControlName]="idType == 'id' ? 'documentId' : 'passport'" [mask]="idType == 'id' ? '000-0000000-0' : undefined" class="form-control" placeholder="id" sharedFormInput type="text" />
          <label>{{ idType == 'id' ? 'Cédula' : 'Pasaporte' }}</label>
        </div>
        <div class="form-group my-3">
          <label class="fw-semibold small">Foto de identificación *</label>
          <file-pond (onaddfile)="handleAddImage($event, pictureTypes.DriverIdPicture)" (onremovefile)="handleRemoveImage($event)"
            [options]="picOptions">
          </file-pond>
        </div>
        <div class="form-floating my-3">
          <input class="form-control" formControlName="address" placeholder="Dirección" sharedFormInput type="text" />
          <label>Dirección</label>
        </div>

        <div class="form-floating my-3">
          <input class="form-control" formControlName="email" placeholder="Correo" sharedFormInput type="text" />
          <label>Correo</label>

        </div>
        <div class="form-floating my-3">
          <input class="form-control" formControlName="phone" mask="000-000-0000" placeholder="phone" sharedFormInput type="text" />
          <label>Teléfono</label>
        </div>
        <div class="form-floating my-3">
          <input class="form-control" formControlName="license" mask="99" placeholder="Categoría de licencia" sharedFormInput type="text" />
          <label>Categoría de licencia (ej: 02)</label>
        </div>
        <div class="form-floating my-3">
          <input class="form-control" formControlName="licenceExpiry" placeholder="Fecha de expiración de la licencia" sharedFormInput type="date" />
          <label>Fecha de expiración de la licencia</label>
        </div>
        <div class="form-group my-3">
          <label class="fw-semibold small">Foto de la licencia</label>
          <file-pond (onaddfile)="handleAddImage($event, pictureTypes.LicensePicture)" (onremovefile)="handleRemoveImage($event)"
            [options]="picOptions">
          </file-pond>
        </div>
        <div class="form-group my-3">
          <label>Relación con el titular de la póliza</label>
          <ng-select [items]="relations" bindLabel="name" bindValue="id" class="form-control" formControlName="relation">
          </ng-select>
        </div>
      </div>
    </div>
  }
    <div class="row align-items-center g-2" formGroupName="vehicle">
      <div class="col-12">
        <h4 class="fs-6 mb-2 d-flex gap-2 align-items-center">
          <span class="material-symbols-outlined">counter_5</span>
          Datos Generales del Vehículo
        </h4>
      </div>
      <div class="col-12">
        <div class="form-check">
          <input class="form-check-input focus-ring focus-ring-dark" formControlName="isTowed" id="isTowed" role="switch"
            type="checkbox">
          <label class="form-check-label" for="isTowed">¿El vehículo no puede moverse por sus propios medios?</label>
        </div>
      </div>
      @if(isTowed){
      <div class="col-12">
        <div class="map-container bg-light rounded-3">
          <app-location-picker (addressChanged)="handleAddressChanged($event)" (dragEnd)="emitVehicleEvent($event)" (placeSelected)="emitVehicleEvent($event)" [center]="vehicleLocationCenter" [hideMapUntilSelected]="true" [mapId]="'vehicleLocationVehicleForm'" [performReverseGeocodeOnDrag]="true" [placeholder]="'Escribe y selecciona la dirección donde está el vehículo'"
                               [validateAddress]="true" [zoom]="zoom"></app-location-picker>
        </div>
      </div>
      }
      <div class="col-12">
        <div [formGroup]="vehicleForm">
          <hr class="border my-2">
          <label class="mb-1">Elige los daños que recibió el vehículo</label>
          <ng-select [items]="impactZones" [multiple]="true" class="form-control h-auto" formControlName="damageDescription"></ng-select>
          <hr class="border mt-3 mb-0">
        </div>
      </div>
      <div class="col-12">
        <label class="fw-semibold small mb-2">Fotos de los daños del vehículo (soporta múltiples imágenes)</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.Damage)" (onremovefile)="handleRemoveImage($event)"
          [options]="picOptionsMultiple">
        </file-pond>
      </div>
      <div class="col-12">
        <label class="fw-semibold small mb-2">Foto panorámica lado izquierdo *</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleLeftSidePicture)" (onremovefile)="handleRemoveImage($event)"
          [options]="picOptions">
        </file-pond>
      </div>
      <div class="col-12">
        <label class="fw-semibold small mb-2">Foto panorámica del lado derecho *</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleRightSidePicture)" (onremovefile)="handleRemoveImage($event)"
          [options]="picOptions">
        </file-pond>
      </div>
      <div class="col-12">
        <label class="fw-semibold small mb-2">Foto panorámica frontal *</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleFrontPicture)" (onremovefile)="handleRemoveImage($event)"
          [options]="picOptions">
        </file-pond>
      </div>
      <div class="col-12">
        <label class="fw-semibold small mb-2">Foto panorámica trasera que se visualice la placa *</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleBackPicture)" (onremovefile)="handleRemoveImage($event)"
          [options]="picOptions">
        </file-pond>
      </div>
      <div class="col-12">
        <label class="fw-semibold small mb-2">Foto numeración del chasis</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleVinPicture)" (onremovefile)="handleRemoveImage($event)"
          [options]="picOptions">
        </file-pond>
      </div>
      <div class="col-12">
        <label class="fw-semibold small mb-2">Foto del millero {{isTowed ? '*' : ''}}</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleMileagePicture)" (onremovefile)="handleRemoveImage($event)"
          [options]="picOptions">
        </file-pond>
      </div>
      <div class="col-12">
        <label class="fw-semibold small mb-2">Foto del marbete</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleMarbetePicture)" (onremovefile)="handleRemoveImage($event)"
          [options]="picOptions">
        </file-pond>
      </div>
      @if(!showDriverForm){
        <div class="col-12">
          <label class="fw-semibold small mb-2">Foto de la cédula del condutor *</label>
          <file-pond (onaddfile)="handleAddImage($event, pictureTypes.DriverIdPicture)" (onremovefile)="handleRemoveImage($event)"
            [options]="picOptions">
          </file-pond>
        </div>
      }
      <div [formGroup]="vehicleForm" class="col-12">
        <div class="form-check my-1">
          <input (change)="handleHasPoliceRegistryChange()" class="form-check-input focus-ring focus-ring-dark" formControlName="hasPoliceRegistry" id="hasPoliceRegistry" sharedFormInput type="checkbox">
          <label class="form-check-label" for="hasPoliceRegistry">
            ¿Tiene registro policial del accidente?
          </label>
        </div>
      </div>
      @if(vehicleForm.value.hasPoliceRegistry){
        <div class="col-12">
          <label class="fw-semibold small mb-2">Foto del registro policial *</label>
          <file-pond (onaddfile)="handleAddImage($event, pictureTypes.PoliceRegistryPicture)" (onremovefile)="handleRemoveImage($event)"
            [options]="picOptions">
          </file-pond>
        </div>
        <div class="col-12">
          <div [formGroup]="vehicleForm" class="form-floating">
            <select class="form-control focus-ring focus-ring-dark" formControlName="policeRegistryDepartment" sharedFormInput>
              @for (department of departmentsValues; track $index) {
                <option [value]="department">
                  {{policeDepartmentTranslation[department]}} {{department == 0 ? '(en un destacamento)' : ''}}
                </option>
              }
            </select>
            <label class="fw-semibold small">Departamento policial</label>
          </div>
        </div>
        <hr class="border mt-3 mb-0">
      }
      <div class="col-12">
        <div class="form-check my-1">
          <input (change)="handlePropertyDamageChange()" [(ngModel)]="hasPropertyDamage" [ngModelOptions]="{standalone: true}" class="form-check-input focus-ring focus-ring-dark" id="hasPropertyDamage" type="checkbox">
          <label class="form-check-label" for="hasPropertyDamage">
            ¿Hubo daños a la propiedad ajena?
          </label>
        </div>
      </div>
      @if(hasPropertyDamage){
        <div class="col-12">
          <div [formGroup]="propertyDamageGroup" class="form-floating">
            <input class="form-control focus-ring focus-ring-dark" formControlName="ownerName" placeholder="Nombre del titular de la propiedad" sharedFormInput type="text" />
            <label>Nombre del titular de la propiedad</label>
          </div>
        </div>
        <div class="col-12">
          <div [formGroup]="propertyDamageGroup" class="form-floating">
            <textarea class="form-control focus-ring focus-ring-dark" formControlName="damageDescription" placeholder="Descripción de daños de la propiedad" sharedFormInput type="text"></textarea>
            <label>Descripción de daños de la propiedad</label>
          </div>
        </div>
        <hr class="border mt-3 mb-0">
      }
      <div class="col-12">
        <div class="form-check my-1">
          <input [(ngModel)]="hasInjured" [ngModelOptions]="{standalone: true}" class="form-check-input focus-ring focus-ring-dark" id="hasInjured" type="checkbox">
          <label class="form-check-label" for="hasInjured">
            ¿Hubo heridos?
          </label>
        </div>
      </div>
      @if (hasInjured){
        <div class="col-12">
          <label>Datos de los heridos</label>
        </div>
        <div class="col-12">
          <table class="table table-sm table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col" class="fw-normal small">Nombre</th>
                <th scope="col" class="fw-normal small">Lesión</th>
                <th scope="col" width="100px"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><input [(ngModel)]="injuredName" [ngModelOptions]="{standalone: true}" class="form-control border focus-ring focus-ring-dark"
                type="text" /></td>
                <td><input [(ngModel)]="injuredLesion" [ngModelOptions]="{standalone: true}" class="form-control border focus-ring focus-ring-dark"
                type="text" /></td>
                <td><button (click)="addInjured( )" class="btn btn-dark w-100 bg-colonia focus-ring focus-ring-dark border-0" type="button">Agregar</button></td>
              </tr>
              @for (injured of injuredList; track $index; let i = $index) {
                <tr>
                  <td>{{ injured.name }}</td>
                  <td>{{ injured.injury }}</td>
                  <td><button (click)="removeInjured( i )" class="btn btn-outline-secondary w-100">Remover</button></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <hr class="border mt-3 mb-0">
      }
    </div>
  </div>
